module.exports = __webpack_public_path__ + "static/media/Flight Delay_ Cancellation.49e3c22a.png";